@if (datatableInfoTextVisible()) {
  <div class="dataTables_info" aria-live="polite">{{ datatableInfoText }}</div>
}
<!-- for another style class="material" -->
<ngx-datatable
  #table
  class="portal-datatable"
  [rows]="rows()"
  [columnMode]="columnMode()"
  rowHeight="auto"
  [headerHeight]="39"
  [count]="count()"
  [offset]="currentOffset()"
  [limit]="limit()"
  [footerHeight]="datatableFooterVisible() ? 50 : 0"
  [selected]="currentSelected()"
  [selectionType]="selectionType()"
  [reorderable]="true"
  [loadingIndicator]="loadingIndicator()"
  [externalPaging]="externalPaging()"
  [externalSorting]="externalSorting()"
  [rowClass]="rowClass"
  [sorts]="$any(sorts())"
  [selectCheck]="singleSelectCheck"
  (page)="onPaginated($event)"
  (sort)="onSort($event)"
  (activate)="onActivate($event)"
  (select)="onSelect($event)">
  @if (rowDetailTemplate()) {
    <ngx-datatable-row-detail [rowHeight]="rowDetailHeight()">
      <ng-template ngx-datatable-row-detail-template>
        <ng-container *ngTemplateOutlet="$any(rowDetailTemplate())"></ng-container>
      </ng-template>
    </ngx-datatable-row-detail>
  }
  <ng-content></ng-content>
  @if (datatableFooterVisible()) {
    <ngx-datatable-footer>
      <ng-template
        ngx-datatable-footer-template
        let-rowCount="rowCount"
        let-pageSize="pageSize"
        let-selectedCount="selectedCount"
        let-curPage="curPage"
        let-offset="offset"
        let-isVisible="isVisible">
        <div class="page-count form-inline">
          <select
            #selectLimit
            name="page-length"
            [(ngModel)]="currentLimit"
            (change)="onChangeRowsLimit(selectLimit.value)"
            class="form-select form-select-sm">
            @for (option of numberOfItemOption(); track $index) {
              <option value="{{ option }}">{{ option }}</option>
            }
          </select>
          <label for="page-length" style="margin-left: 2px">{{ optionText() }}</label>
        </div>
        <datatable-pager
          pagerLeftArrowIcon="datatable-icon-left"
          pagerRightArrowIcon="datatable-icon-right"
          pagerPreviousIcon="datatable-icon-prev"
          pagerNextIcon="datatable-icon-skip"
          [page]="curPage"
          [size]="pageSize"
          [count]="rowCount"
          [hidden]="!(rowCount / pageSize > 1)"
          (change)="table.onFooterPage($event); pageChanged()">
        </datatable-pager>
      </ng-template>
    </ngx-datatable-footer>
  }
</ngx-datatable>
